import React from "react";
import { Inbox } from "lucide-react";
import { Card, CardContent, Button } from "@/components/ui";
import type { AttributeReviewEmptyStateProps } from "./AttributeReviewEmptyState.types";

export const AttributeReviewEmptyState: React.FC<
  AttributeReviewEmptyStateProps
> = ({ onBackToCatalog }) => {
  return (
    <Card>
      <CardContent className="py-16 text-center">
        <Inbox className="w-14 h-14 mx-auto mb-4 text-slate-400 dark:text-slate-500" />
        <h3 className="text-lg font-semibold text-slate-900 dark:text-slate-100 mb-2">
          No pending products available for review
        </h3>
        <p className="text-sm text-slate-500 dark:text-slate-400 mb-6 max-w-md mx-auto">
          There are no product types waiting for attribute review. Run a mapping
          session from the catalog flow to see pending products here.
        </p>
        <Button variant="secondary" onClick={onBackToCatalog}>
          Back to Catalog
        </Button>
      </CardContent>
    </Card>
  );
};
